module.exports = __webpack_public_path__ + "img/efimov.ec31de91.png";